import React, { Component } from "react";
import StickyHeader from "react-sticky-header";
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Container,
  Collapse,
  Button,
} from "reactstrap";
import ScrollspyNav from "./scrollSpy";
import "../../../node_modules/react-sticky-header/styles.css";
import "./NavBarPage.css";

class Navbar_Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "services", navheading: "Services" },
        { id: 3, idnm: "about", navheading: "About Us" },
        { id: 4, idnm: "pricing", navheading: "Pricing" },
        { id: 5, idnm: "contact", navheading: "Contact Us" },
      ],
      isOpenMenu: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth > 991 && this.state.isOpenMenu) {
      this.setState({ isOpenMenu: false });
    }
  };

  toggleMenu = () => {
    this.setState((prev) => ({ isOpenMenu: !prev.isOpenMenu }));
  };

  closeMenu = () => {
    if (window.innerWidth <= 991) {
      this.setState({ isOpenMenu: false });
    }
  };

  render() {
    const targetIds = this.state.navItems.map((item) => item.idnm);

    return (
      <StickyHeader
        header={
          <div
            className="pwlp-navbar navbar navbar-expand-lg fixed-top"
            id="navbar"
          >
            <Container className="pwlp-navbar__container">
              <NavbarBrand className="pwlp-navbar__brand" href="/">
                <img
                  src="/logo670.png"
                  alt="PayWeek Logo"
                  className="pwlp-navbar__logo"
                />
              </NavbarBrand>

              <NavbarToggler
                onClick={this.toggleMenu}
                className="pwlp-navbar__toggler"
                aria-expanded={this.state.isOpenMenu}
                aria-label="Toggle navigation"
              >
                <span className="pwlp-navbar__toggler-icon">☰</span>
              </NavbarToggler>

              <Collapse isOpen={this.state.isOpenMenu} navbar className="pwlp-navbar__collapse">
                <div className="pwlp-navbar__content">
                  <ScrollspyNav
                    scrollTargetIds={targetIds}
                    activeNavClass="pwlp-navbar__item--active"
                    scrollDuration="400"
                    headerBackground="true"
                  >
                    <Nav navbar className="pwlp-navbar__nav">
                      {this.state.navItems.map((item) => (
                        <NavItem key={item.id} className="pwlp-navbar__item">
                          <NavLink
                            href={`#${item.idnm}`}
                            className="pwlp-navbar__link"
                            onClick={this.closeMenu}
                          >
                            {item.navheading}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                  </ScrollspyNav>

                  <Nav navbar className="pwlp-navbar__actions">
                    <NavItem>
                      <Button
                        type="button"
                        className="pwlp-navbar__btn pwlp-navbar__btn--primary"
                        onClick={() => {
                          window.location.href = "/register";
                          this.closeMenu();
                        }}
                      >
                        Get started
                      </Button>
                    </NavItem>

                    <NavItem>
                      <Button
                        type="button"
                        className="pwlp-navbar__btn pwlp-navbar__btn--secondary"
                        onClick={() => {
                          window.location.href = "/login";
                          this.closeMenu();
                        }}
                      >
                        Business Login
                      </Button>
                    </NavItem>

                    <NavItem>
                      <Button
                        type="button"
                        className="pwlp-navbar__btn pwlp-navbar__btn--secondary"
                        onClick={() => {
                          window.location.href = "/emp-login";
                          this.closeMenu();
                        }}
                      >
                        Employee Login
                      </Button>
                    </NavItem>
                  </Nav>
                </div>
              </Collapse>
            </Container>
          </div>
        }
        stickyOffset={-100}
      />
    );
  }
}

export default Navbar_Page;


// import React, { Component } from "react";
// import StickyHeader from "react-sticky-header";
// import {
//   Nav,
//   NavbarBrand,
//   NavbarToggler,
//   NavItem,
//   NavLink,
//   Container,
//   Collapse,
//   Button,
// } from "reactstrap";
// import ScrollspyNav from "./scrollSpy";
// import "../../../node_modules/react-sticky-header/styles.css";
// import "./NavBarPage.css";

// class Navbar_Page extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       navItems: [
//         { id: 1, idnm: "home", navheading: "Home" },
//         { id: 2, idnm: "features", navheading: "Features" },
//         { id: 3, idnm: "services", navheading: "Services" },
//         { id: 4, idnm: "about", navheading: "About" },
//         { id: 5, idnm: "pricing", navheading: "Pricing" },
//         { id: 6, idnm: "contact", navheading: "Contact" },
//       ],
//       isOpenMenu: false,
//     };
//   }

//   componentDidMount() {
//     // Close menu when resizing above 992px
//     window.addEventListener("resize", this.handleResize);
//   }

//   componentWillUnmount() {
//     window.removeEventListener("resize", this.handleResize);
//   }

//   handleResize = () => {
//     if (window.innerWidth > 992 && this.state.isOpenMenu) {
//       this.setState({ isOpenMenu: false });
//     }
//   };

//   toggleMenu = () => {
//     this.setState((prevState) => ({ isOpenMenu: !prevState.isOpenMenu }));
//   };

//   closeMenu = () => {
//     if (window.innerWidth <= 992) {
//       this.setState({ isOpenMenu: false });
//     }
//   };

//   render() {
//     let TargetId = this.state.navItems.map((item) => item.idnm);

//     return (
//       <React.Fragment>
//         <StickyHeader
//           header={
//             <div
//               className={
//                 this.props.navClass +
//                 " navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark"
//               }
//               id="navbar"
//             >
//               <Container>
//                 <NavbarBrand className="logo" href="/">
//                   <i className="mdi"></i>
//                   <img 
//                     src="/logo670.png" 
//                     alt="Payweek Logo"  
//                     className="m-logo"
//                     />
//                 </NavbarBrand>

                

//                 {/* Navbar Toggler for Small Screens */}
//                 <NavbarToggler
//                   onClick={this.toggleMenu}
//                   aria-expanded={this.state.isOpenMenu}
//                 >
//                   <i className="mdi mdi-menu"></i>
//                 </NavbarToggler>

//                 <Collapse isOpen={this.state.isOpenMenu} navbar>
//                   <ScrollspyNav
//                     scrollTargetIds={TargetId}
//                     activeNavClass="active"
//                     scrollDuration="400"
//                     headerBackground="true"
//                   >
//                     <Nav className="navbar-nav">
//                       {this.state.navItems.map((item, key) => (
//                         <NavItem key={key}>
//                           <NavLink href={"#" + item.idnm} onClick={this.closeMenu}>
//                             {item.navheading}
//                           </NavLink>
//                         </NavItem>
//                       ))}
//                     </Nav>
//                   </ScrollspyNav>
//                   <div className="nav-button ms-auto">
//                     <Nav className="navbar-right navbar">
//                       <NavItem>
//                         <Button
//                           type="button"
//                           color="warning"
//                           className="navbar-btn btn-rounded waves-effect waves-light custom-register-button"
//                           onClick={() => {
//                             window.location.href = "/register";
//                             this.closeMenu();
//                           }}
//                         >
//                           Register
//                         </Button>
//                       </NavItem>
//                       <NavItem>
//                         <Button
//                           type="button"
//                           className="navbar-btn btn-rounded waves-effect waves-light custom-login-button"
//                           onClick={() => {
//                             window.location.href = "/login";
//                             this.closeMenu();
//                           }}
//                         >
//                           Business Login
//                         </Button>
//                       </NavItem>
//                       <NavItem>
//                         <Button
//                           type="button"
//                           className="navbar-btn btn-rounded waves-effect waves-light custom-emp-login-button"
//                           onClick={() => {
//                             window.location.href = "/emp-login";
//                             this.closeMenu();
//                           }}
//                         >
//                           Employee Login
//                         </Button>
//                       </NavItem>
//                     </Nav>
//                   </div>
//                 </Collapse>
//               </Container>
//             </div>
//           }
//           stickyOffset={-100}
//         />
//       </React.Fragment>
//     );
//   }
// }

// export default Navbar_Page;




// import React, { Component } from "react";
// import StickyHeader from "react-sticky-header";
// import {
//   Nav,
//   NavbarBrand,
//   NavbarToggler,
//   NavItem,
//   NavLink,
//   Container,
//   Collapse,
//   Button,
// } from "reactstrap";
// import ScrollspyNav from "./scrollSpy";

// //Import Stickey Header

// import "../../../node_modules/react-sticky-header/styles.css";

// class Navbar_Page extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       navItems: [
//         { id: 1, idnm: "home", navheading: "Home" },
//         { id: 2, idnm: "features", navheading: "Features" },
//         { id: 3, idnm: "services", navheading: "Services" },
//         { id: 3, idnm: "about", navheading: "About" },
//         { id: 4, idnm: "pricing", navheading: "Pricing" },
//         { id: 5, idnm: "blog", navheading: "Blog" },
//         { id: 6, idnm: "contact", navheading: "Contact" },
//       ],
//       isOpenMenu: false,
//     };
//   }

//   toggle = () => {
//     this.setState((prevState) => ({ isOpenMenu: !prevState.isOpenMenu }));
//   };
  

//   // toggle = () => {
//   //   this.setState({ isOpenMenu: !this.state.isOpenMenu });
//   // };


//   closeMenu = () => {
//     if (window.innerWidth <= 992) {
//       this.setState({ isOpenMenu: false });
//     }
//   };


//   render() {

//       /********************* Menu Js **********************/

//     function windowScroll() {
//       const navbar = document.getElementById("navbar");
//       if (
//           document.body.scrollTop >= 50 ||
//           document.documentElement.scrollTop >= 50
//       ) {
//           navbar.classList.add("nav-sticky");
//       } else {
//           navbar.classList.remove("nav-sticky");
//       }
//   }
  
//   window.addEventListener('scroll', (ev) => {
//       ev.preventDefault();
//       windowScroll();
//   });

//     //Store all Navigationbar Id into TargetID variable(Used for Scrollspy)
//     let TargetId = this.state.navItems.map((item) => {
//       return item.idnm;
//     });

//     return (
//       <React.Fragment>
//         <StickyHeader
//           header={
//             <div
//               className={
//                 this.props.navClass + " navbar navbar-expand-lg fixed-top  navbar-custom sticky sticky-dark"
//               }
//               id="navbar"
//             >
//               <Container>
//                 <NavbarBrand className="logo text-uppercase" href="/">
//                   <i className="mdi mdi-alien"></i>GINOC
//                 </NavbarBrand>

//                 <NavbarToggler className="" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" onClick={this.toggle}>
//                   <i className="mdi mdi-menu"></i>
//                 </NavbarToggler>

//                 <Collapse
//                   id="navbarCollapse"
//                   isOpen={this.state.isOpenMenu}
//                   navbar
//                 >
//                   <ScrollspyNav
//                     scrollTargetIds={TargetId}
//                     activeNavClass="active"
//                     scrollDuration="800"
//                     headerBackground="true"
//                   >
//                     <Nav className="navbar-nav navbar-center" id="mySidenav">
//                       {this.state.navItems.map((item, key) => (
//                         <NavItem
//                           key={key}
//                           className={item.navheading === "Home" ? "active" : ""}
//                         >
//                           <NavLink href={"#" + item.idnm}>
//                             {" "}
//                             {item.navheading}
//                           </NavLink>
//                         </NavItem>
//                       ))}
//                     </Nav>
//                   </ScrollspyNav>
//                   <div className="nav-button ms-auto">
//                     <Nav className="navbar-right navbar">
//                       <NavItem>
//                         <Button
                        
//                           type="button"
//                           color="warning"
//                           className=" btn-rounded waves-effect waves-light custom-register-button"
//                           onClick={() => window.location.href = "/register"}
//                         >
//                           Register
//                         </Button>
//                       </NavItem>
//                       <NavItem>
//                         <Button
                          
//                           type="button"
//                           color="success"
//                           className="btn-rounded waves-effect waves-light custom-login-button"
//                           onClick={() => window.location.href = "/login"}
//                         >
//                           Business Login
//                         </Button>
//                       </NavItem>
//                       <NavItem>
//                         <Button
                        
//                           type="button"
//                           color="success"
//                           className="btn-rounded waves-effect waves-light custom-login-button"
//                           onClick={() => window.location.href = "/emp-login"}
//                         >
//                           Employee Login
//                         </Button>
//                       </NavItem>
//                     </Nav>
//                   </div>
//                 </Collapse>
//               </Container>
//             </div>
//           }
//           stickyOffset={-100}
//         ></StickyHeader>
//       </React.Fragment>
//     );
//   }
// }

// export default Navbar_Page;
